
import { i18nText } from '@/locales';

import {Component, Vue} from "vue-property-decorator";
import PageTitle from "@/UI/components/common/PageTitle.vue";
import {ITableColumn} from "@/entity/table/table.types";
import PaymentArticlesAddForm from "@/form/finance/payment_articles/PaymentArticlesAddForm";
import PaymentArticlesUpdateForm from "@/form/finance/payment_articles/PaymentArticlesUpdateForm";
import PaymentArticlesAddComponent
  from "@/UI/components/forms/finance/payment_articles/PaymentArticlesAddComponent.vue";
import PaymentArticlesUpdateComponent
  from "@/UI/components/forms/finance/payment_articles/PaymentArticlesUpdateComponent.vue";

import ModalWrapper from "@/UI/components/common/ModalWrapper.vue";
import {IPaymentArticlesListItem} from "@/entity/finance/payment_articles/paymentArticles.types";
import {mixins} from "vue-class-component";
import BaseDataForm from "@/UI/components/Helpers/BaseForm/BaseDataForm.vue";
import {Button, Col, FormModel, List, Menu, Modal, Row, Select, Table} from "ant-design-vue";
import {
  PaymentArticlesFormData,
  articlesRules,
  PaymentTypes,
} from "@/form/finance/payment_articles/PaymentArticles";
import {getStudioId} from "@/UI/lib/state";
import {PaymentArticlesMix} from "@/UI/mixins/Finance/PaymentArticlesMix";
import {PaymentArticlesStore} from "@/store/modules/PaymentArticles";
import {FiltersData} from '@/entity/filters/extFilter';
import {showNotification, showNotificationSimple} from "@/UI/lib/messages";
import SortComponent from "@/UI/components/Helpers/components/SortComponent.vue";
import {ProxyGetData} from "@/UI/components/Helpers/getData";
import {appPaginationStore} from "@/store/modules/appPagination";

@Component({
  components: {
    "a-button": Button,
    "a-menu-item": Menu.Item,
    "a-list-item": List.Item,
    "a-list-item-meta": List.Item.Meta,
    "a-select": Select,
    "a-select-option": Select.Option,
    "a-table": Table,
    "a-modal": Modal,
    "a-form-model-item": FormModel.Item,
    "a-form-model": FormModel,
    "a-row": Row,
    "a-col": Col,

    ModalWrapper,
    PageTitle,
    PaymentArticlesAddComponent,
    PaymentArticlesUpdateComponent,
    BaseDataForm,
    SortComponent
    
  },
})
export default class PaymentArticles extends mixins(PaymentArticlesMix, ProxyGetData) {
  filtersData = new FiltersData();
  formData = new PaymentArticlesFormData(getStudioId(this));
  showModal = false;
  modalTitle = "";
  rules = articlesRules;
  pTypes = PaymentTypes;
  mode = 0;
  saving = false;

  get canManage(): boolean {
    return Vue.auth.check(['owner', 'admin']);
  }


  form = new PaymentArticlesAddForm();
  updateForm = new PaymentArticlesUpdateForm();
  //paymentArticle: IPaymentArticlesListItem | null = null;
  searchText = "";

  //searchTypeName = "";

  searchedColumn = "";
  showAddModal = false;
  showUpdateModal = false;
  filterData: any;

  showDialog(mode: number, record?: IPaymentArticlesListItem): void {
    if (mode === 1 && record && !record.internal) {
      if (record) {
        this.mode = 1;
        this.formData["id"] = record["id"];
        this.formData["name"] = record["name"];
        this.formData["type_id"] = record["type_id"];
        this.formData["salon_id"] = record["salon_id"];
        this.formData["comment"] = record["comment"];
      }
    }
    if (mode === 0) {
      this.mode = 0;
      this.formData = new PaymentArticlesFormData(getStudioId(this));
    }
    this.showModal = true;
  }

  async onSubmit(): Promise<void> {
    if (this.saving) return;
    (this.$refs.PaymentArticlesFormData as FormModel).validate(async valid => {
      if (!valid || this.saving) return;
      this.saving = true;
      try {
        const response = this.mode === 0
          ? await PaymentArticlesStore.create(this.formData)
          : await PaymentArticlesStore.update(this.formData);
        this.$message.open({type: response.status ? 'success' : 'error', content: response.response});
        if (response.status) {
          this.onCancel();
          await this.refreshArticles();
        }
      } catch (error) {
        const response = error.response?.data;
        this.$message.error(response?.response || response?.message || error.message);
      } finally {
        this.saving = false;
      }
    });
  }

  async refreshArticles(): Promise<void> {
    this.proxyFilter = {salon_id: getStudioId(this)};
    appPaginationStore.setCurrent(1);
    if (this.pager) this.pager.current = 1;
    await this.sortedData('desc', {dataIndex: 'created_at'});
  }

  onCancel(): void {
    this.showModal = false;
  }

  async onDelete(): Promise<void> {
    if (!this.formData.id || this.saving) return;
    this.saving = true;
    try {
      const response = await PaymentArticlesStore.delete({id: Number(this.formData.id), salon_id: getStudioId(this)} as any);
      this.$message.open({type: response.status ? 'success' : 'error', content: response.response});
      if (response.status) {
        this.onCancel();
        await this.refreshArticles();
      }
    } catch (error) {
      const response = error.response?.data;
      this.$message.error(response?.response || response?.message || error.message);
    } finally {
      this.saving = false;
    }
  }

  async created(): Promise<void> {
    try {
      await this.refreshArticles();
    } finally {
      this.formReady = true;
    }
  }

  get columns(): ITableColumn[] {
    return [
      {
        title: i18nText("Название"),
        dataIndex: "name",
        key: "name",
        scopedSlots: {
          filterDropdown: "filterDropdown",
          filterIcon: "filterIcon",
          customRender: "name",
        },
      },
      {
        title: i18nText("Тип статьи"),
        dataIndex: "type_name",
        key: "type_name",
        scopedSlots: {

          filterDropdown: "filterDropdown",
          filterIcon: "filterIcon",
          customRender: "type",
        },
      },
    ];
  }

  async setFilter({by, sort}: { by: string; sort: any }): Promise<void> {
    await this.sortedData(by, {dataIndex: sort.dataIndex})
  }

  /*async submit(): Promise<void> {
       if (checkUserRole() == "admin" && this.$store.state.salon_id) {
          this.form.salon_id = this.$store.state.salon_id;
      } else if (checkUserRole() == "owner") {
          const userData = getUserData();
          this.form.salon_id = userData.studios;
      }
      const response = await this.form.submit(PaymentArticlesStore.create);
      if (response) {
          //this.fetchTableItems();
          this.showAddModal = false;
          this.form = new PaymentArticlesAddForm();
      }
  }*/

  /*async updateSubmit(): Promise<void> {
      if (await this.updateForm.submit(PaymentArticlesStore.update)) {
          //this.fetchTableItems();
          this.showUpdateModal = false;
          if (this.paymentArticles && this.paymentArticles.data) {
              if (this.paymentArticle) {
                  for (let i = 0; i < this.paymentArticles.data.length; i++) {
                      if (this.paymentArticle.id == this.paymentArticles.data[i].id) {
                          this.paymentArticle = this.paymentArticles.data[i];
                          break;
                      }
                  }
              }
          }
          this.updateForm = new PaymentArticlesUpdateForm();
      }
  }*/
  /*async handleAddModal(visible: boolean): Promise<void> {
      if (visible) {
          this.form.setFormData(await this.paymentArticlesTypes());
      }
      this.showAddModal = visible;
  }

  async paymentArticlesTypes(data?: Record<string, any>): Promise<IPaymentArticlesType[]> {
      if (!PaymentArticlesTypeStore.items) {
          await PaymentArticlesTypeStore.fetchAll();
      }

      if (PaymentArticlesTypeStore.items) {
          return PaymentArticlesTypeStore.items;
      } else {
          return [];
      }
  }

  async handleUpdateModal(visible: boolean): Promise<void> {
      /!*    this.showUpdateModal = visible;
      this.updateForm.setFormData(this.paymentArticle, await this.paymentArticlesTypes());*!/
  }

  show(paymentArticle: IPaymentArticlesListItem): void {
      /!* this.paymentArticle = paymentArticle;
      this.handleUpdateModal(true);*!/
  }*/
}
